import React, { FC, useMemo } from 'react';
import orderBy from 'lodash/orderBy';
import { SloQualityResultItemDTO } from '@atlassiansox/phobos-client-ts';

import { flexStart, spaceTopCompact } from '@/styles';

import * as styles from './styles';
import { testIds } from './constants';

type QualityScoreCheckMetadataProps = Pick<SloQualityResultItemDTO, 'metaData'>;

const QualityScoreCheckMetadata: FC<QualityScoreCheckMetadataProps> = ({ metaData = {} }) => {
  const items = useMemo(
    () =>
      orderBy(Object.keys(metaData).filter(x => x !== 'warning')).map((key: string) => ({
        key,
        value: metaData[key],
      })),
    [metaData]
  );

  return (
    <ul
      data-testid={testIds.qualityScoreCheckMetadata}
      css={[styles.itemMetadataTableStyles, spaceTopCompact]}
    >
      {items.map(({ key, value }) => (
        <li key={key} css={flexStart}>
          <code>{key}</code>
          <code>{value}</code>
        </li>
      ))}
    </ul>
  );
};
export default QualityScoreCheckMetadata;
